import { useTranslations } from "next-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "../Button";

function CloseButton({
  trackingName = "",
  variant = "ghost-dark",
  size,
  className,
  title,
  ...other
}) {
  const t = useTranslations("common");

  return (
    <Button
      trackingName={trackingName}
      title={title || t("close")}
      leftIconName="close"
      variant={variant}
      size={size}
      className={classNames("close", className)}
      {...other}
    />
  );
}

CloseButton.propTypes = {
  variant: PropTypes.string,
  trackingName: PropTypes.string,
};

export default CloseButton;
